import classNames from 'classnames';
import { Championship } from 'modules/tournaments/domain/interfaces/responce-dto';
import { TourneyEncoded } from 'modules/tournaments/domain/interfaces/tourney-encoded';
import TourneyComponentsTourneyCard from 'modules/tournaments/ui/components/tourney-card';
import React from 'react';
import MainComponentsEmptyListMessage from '../empty-message';
import * as S from './styles';

type Props = {
  tourneys: Championship[];
  onDetail: (id: TourneyEncoded['id']) => any;
};

const MainComponentsTourneysList = (props: Props) => {
  const { tourneys, onDetail } = props;
  const isEmpty = !tourneys.length;

  return (
    <S.ListContainer
      className={classNames('w-full px-6', {
        empty: isEmpty,
      })}
    >
      <div className="grid grid-cols-12 gap-3">
        {tourneys.map((tourney) => (
          <div className="col-span-4" key={tourney.id}>
            <TourneyComponentsTourneyCard
              key={tourney.id}
              tourney={tourney}
              containerProps={{ className: 'item' }}
              onClickCard={onDetail}
            />
          </div>
        ))}
        {isEmpty && <MainComponentsEmptyListMessage />}
      </div>
    </S.ListContainer>
  );
};

export default MainComponentsTourneysList;
